import { useState } from 'react';
import { Portal, svgSprite } from '../../../../hybrid/wrappers';
import TTMaps from '../../../ttmaps/TTMaps/TTMaps';
import PropTypes from 'prop-types';
import css from './FormMap.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../common/utils/styles';

const FormMap = ({ setDisabledClick, attribute, handlers, textButton, setFormData, compStyle }) => {
    const { stylers, classes } = generateCompStylers(compStyle);

    const [active, setActive] = useState(false);
    return (
        <div style={stylers.wrapper} className={classnames(classes.wrapper)}>
            <div
                style={stylers.button}
                className={classnames(css.buttonWrapper, classes.button)}
                onClick={() => {
                    setDisabledClick(true);
                    handlers?.onFocus && handlers?.onFocus(attribute);
                    setActive(!active);
                }}
            >
                <div className={css.svgWrapper}>
                    {svgSprite('pin', {
                        width: '20px',
                        height: '20px',
                        fill: 'var(--blueColor)'
                    })}
                </div>
                <p style={{ margin: '0 6px', lineHeight: '20px' }}>{textButton}</p>
            </div>
            {active ? (
                <Portal
                    closeHandler={() => {
                        setActive(false);
                        setDisabledClick(false);
                    }}
                >
                    <div
                        style={{
                            height: '90%',
                            width: '90%',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 100,
                            overflow: 'hidden'
                        }}
                    >
                        <TTMaps
                            onClick={(e) => {
                                const { lng, lat } = e?.lngLat;
                                setActive(false);
                                setFormData(attribute, {
                                    id: e?.point?.x,
                                    lat,
                                    lng
                                });
                                handlers?.onBlur && handlers?.onBlur(attribute);
                                setTimeout(() => {
                                    setDisabledClick(false);
                                }, 200);
                            }}
                        />
                    </div>
                </Portal>
            ) : null}
        </div>
    );
};
FormMap.propTypes = {
    styles: PropTypes.object,
    setDisabledClick: PropTypes.func,
    attribute: PropTypes.string,
    handlers: PropTypes.object,
    textButton: PropTypes.node,
    setFormData: PropTypes.func,
    compStyle: PropTypes.object
};
export default FormMap;
